<template>
  <div :class="{ box: true, bosFixed: isFixed }" v-if="visible">
    <div>
      <div :class="{ formContent: true, formContentLeft: isFixed }">
        <div class="form-con">
          <div v-if="isVerification" class="form-verification">
            已发送手机验证码
          </div>

          <img
            class="form-img"
            src="https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud%2FbackendUpload%2F20230712102533913-Background.png"
            alt=""
            @click="onFormImg"
          />
          <img class="form-imgs" :src="imgIcon" alt="" @click="onFormImg" />
          <div class="form">
            <div class="title-tag">
              <span class="h2">欢迎来到合创汽车</span>
            </div>
            <div v-if="isCanGetIcon">
              <span style="line-height: 40px;">手机号</span>
              <div class="form-item">
                <input
                  type="text"
                  class="form-item-ipt"
                  placeholder="请输入手机号"
                  v-model="form.mobile"
                  maxlength="11"
                />
              </div>
              <p class="input-error">{{ message.pError }}</p>
              <span style="line-height: 40px;">验证码</span>
              <div class="form-item">
                <input
                  type="text"
                  class="form-item-ipt"
                  placeholder="请输入验证码"
                  v-model="form.code"
                  maxlength="10"
                  @blur="blurInput"
                />
                <a
                  style="color:#00B9EF ;"
                  :class="{ colorValue: !isCanGetCode }"
                  @click="getCode"
                >
                  {{ isCanGetCode ? "获取验证码" : `重新获取${codeRestTime}s` }}
                </a>
              </div>
              <p class="input-error">{{ message.nError }}</p>
              <div class="form-contact">
                <GacRadio @change="toggleSelect">
                  <div class="form-radio-label">
                    <span class="textSubtitleColor">我已阅读并同意</span>
                    <span style="color: #00B9EF;" @click.stop="togglePrivacy"
                      >《用户隐私条款》</span
                    >
                  </div>
                </GacRadio>
              </div>
              <div
                :class="{ 'form-btn': true, 'form-btn-background': isAgree }"
                @click="submitNow"
              >
                登录/注册
              </div>
            </div>
            <div v-else id="login-scan"></div>
          </div>
          <div
            v-if="isFixed"
            style="margin-top: 40px;display: flex;justify-content: center;"
            @click="onTure"
          >
            <img
              src="https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20230712160122356-Close.png"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
    <gac-popup v-model="showPrivacy" position="center">
      <div class="dialog-body">
        <div class="dialog-body-privacy">
          <div class="privacy">
            <iframe
              width="100%"
              height="100%"
              src="https://static.hycan.com.cn/linkurl/agreement.html?id=8"
            ></iframe>
          </div>
        </div>
        <div class="dialog-close" @click="togglePrivacy">
          <img
            @click.prevent
            src="https://azure-shop.obs.cn-south-1.myhuaweicloud.com/20191224095246411-website_icon_gb_usp.png"
          />
        </div>
      </div>
    </gac-popup>
  </div>
</template>
<script src="https://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js"></script>
<script>
import { getToast, getConfirm } from "@/components/Login/popupLogin";
import Floor from "@components/Floor/index.vue";
import Header from "@components/Header/index.vue";
import ProvinceSelect from "@components/ProvinceSelect/index.vue";
import GacPopup from "@components/DialogMask/index.vue";
import GacRadio from "@components/Login/Rds/index.vue";
import TabNoneResponse from "@components/TabNoneResponse";
import ServiceShopSelect from "@components/ServiceShopSelect";
import utils from "@utils";
import { mobileCode, mobileLogin } from "@/services/login";
const CODE_TIME = 60;

export default {
  name: "test-drive",
  components: {
    Header,
    Floor,
    ProvinceSelect,
    "gac-popup": GacPopup,
    GacRadio,
    TabNoneResponse,
    ServiceShopSelect,
  },
  props: {
    success: {
      type: Function,
      default: function() {
        return "";
      },
    },
    isFixed: {
      type: Boolean,
      default: true,
    },
    hrefUrl: {
      type: String,
      default: "/login.html",
    },
    value: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isCanGetIcon: true,
      isCanGetCode: true,
      isShowToast: false,
      isVerification: false,
      imgIcon:
        "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud%2FbackendUpload%2F20230713114054996-icon_weixin.png",
      toastText: "",
      isAgree: false,
      showPrivacy: false,
      tabDefaultValue: 3,
      codeRestTime: CODE_TIME,
      form: {
        code: "",
        mobile: "",
      },
      message: {
        nError: "",
        pError: "",
      },
    };
  },
  created() {},
  mounted() {
    const script = document.createElement("script");
    script.src =
      "https://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js";
    script.onload = this.initScanLogin;
    document.head.appendChild(script);
  },
  methods: {
    async getCode() {
      const { isCanGetCode, form } = this;
      if (form.mobile === "") {
        return this.openToast("请先输入手机号");
      }
      if (isCanGetCode) {
        try {
          await mobileCode({
            mobile: form.mobile,
          });
          this.getVerification();
          this.isCanGetCode = false;
          this.interval = setInterval(() => {
            this.codeRestTime = this.codeRestTime - 1;
            if (this.codeRestTime === 0) {
              clearInterval(this.interval);
              this.isCanGetCode = true;
              this.codeRestTime = CODE_TIME;
            }
          }, 1000);
        } catch (error) {
          console.error(error);
        }
      }
    },
    getVerification() {
      this.isVerification = true;
      setTimeout(() => {
        this.isVerification = false;
      }, 3000);
    },
    openToast(text) {
      this.toastText = text;
      if (this.toastTimeout) {
        clearTimeout(this.toastTimeout);
        this.toastTimeout = null;
      }
      this.isShowToast = true;
      this.toastTimeout = setTimeout(() => {
        this.isShowToast = false;
      }, 2000);
    },
    toggleSelect(val) {
      this.isAgree = val;
    },
    togglePrivacy() {
      this.showPrivacy = this.showPrivacy ? false : true;
    },
    blurInput() {
      if (!this.isRealName()) {
        this.message.nError = "请输入正确的验证码";
      } else {
        this.message.nError = "";
      }
    },
    isRealPhone() {
      let phone = this.form.mobile;
      return phone && phone.match(/^[1][0-9]{10}$/);
    },
    isRealName() {
      let userName = this.form.userName;
      return /^[a-zA-Z\u4e00-\u9fa5]*$/g.test(userName);
    },
    // 提交登录
    submitNow(e) {
      e.preventDefault();
      if (this.loading) return;

      if (!this.form.code && !this.form.mobile) {
        getToast().open({
          text: "请输入手机号码",
        });
        return;
      }
      if (!this.isAgree) {
        getToast().open({
          text: "请勾选协议",
        });
        return;
      }

      this.loading = true;

      mobileLogin({ ...this.form })
        .then((data) => {
          const { accessToken } = data.data;
          localStorage.setItem("accessToken", JSON.stringify(accessToken));
          this.success(data);
          const urls = window.location.href;
          if (urls.includes("/optional.html")) {
            window.location.href = `${this.hrefUrl}&fromLogin=yes`;
          } else {
            history.replaceState(null, "", document.referrer);
            window.location = document.referrer;
            // window.location.href = this.hrefUrl;
          }
        })
        .finally((error) => {
          this.loading = false;
        });
    },
    initScanLogin() {
      const oring = window.location.origin;
      const cs = "https://www-test.gac-nio.com/";
      // const url = `https://open.weixin.qq.com/connect/qrconnect?appid=${appid}&redirect_uri=${redirect_uri}&response_type=${response_type}&scope=${scope}#wechat_redirect`
      let interval = setInterval(() => {
        if (window.WxLogin) {
          clearInterval(interval);
          var Obj = new window.WxLogin({
            self_redirect: false,
            id: "login-scan",
            appid: "wx29951ae23de3712c",
            scope: "snsapi_login",
            redirect_uri: `${oring}/auth.html`,
            state: this.hrefUrl,
            style: "black",
            title: "",
          });
          const $login = document.querySelector("#login-scan");
          const $frame = $login.querySelector("iframe");
          $frame.style.transform = "scale(0.95)"; /* 设置缩放比例 */
        }
      }, 20);
    },
    onTure() {
      this.visible = false;
    },
    onFormImg() {
      this.isCanGetIcon = !this.isCanGetIcon;
      if (this.isCanGetIcon) {
        this.imgIcon =
          "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud%2FbackendUpload%2F20230713114054996-icon_weixin.png";
      } else {
        this.imgIcon =
          "https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud%2FbackendUpload%2F20230713114102589-pic_phone2.png";
      }
      this.initScanLogin();
    },
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@style/base";
@import "@style/common";

@include setThemeClass {
  .box {
    @include media(
      (
        $md: (
          position: fixed,
          top: 0,
          left: 0,
          width: 100%,
          height: 100%,
          z-index: 2,
        ),
        $sm: (
          position: fixed,
          top: 0,
          left: 0,
          width: 100%,
          height: 100%,
          z-index: 2,
        ),
      )
    );
    .formContent {
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      width: 100%;
      padding: 0 8%;
      display: flex;
      align-items: center;
      border-radius: 8px;

      @include media(
        (
          $md: (
            justify-content: center,
            padding: 0 49px,
            position: relative,
            top: 100px,
          ),
          $sm: (
            padding: 0 30px,
            top: 100px,
            padding-bottom: 30px,
          ),
        )
      );
    }
    .formContentLeft {
      justify-content: center !important ;
    }
    .form-con {
      position: relative;
      background: getThemeVal(cardColorWhite);
      border-radius: 8px !important;
      // width: 410px !important;
      font-size: 14px;
      height: 428px;
      @include media(
        (
          $lg: (
            width: 410px,
          ),
          $bg: (
            width: 410px,
          ),
          $md: (
            width: 410px,
          ),
          $sm: (
            width: 100%,
          ),
        )
      );
      .form-verification {
        display: flex;
        justify-content: center;
        align-items: center;
        color: #ffffff;
        position: absolute;
        border-radius: 50px;
        left: 50%;
        top: 48%;
        height: 48px;
        width: 152px;
        background-color: rgba(0, 0, 0, 0.8);
        transform: translate(-50%, -50%);
      }
      .form-img {
        border-top-right-radius: 8px;
        height: 60px;
        width: 60px;
        position: absolute;
        right: 0;
      }
      .form-imgs {
        border-top-right-radius: 8px;
        height: 30px;
        width: 30px;
        margin: 2px;
        position: absolute;
        right: 0;
      }
    }
    .form {
      // background: getThemeVal(cardColorWhite);
      border-radius: 8px !important;
      // width: 410px !important;
      // height: 428px;
      padding: 40px 30px;
      font-size: 14px;
      @include media(
        (
          $lg: (
            width: 410px,
          ),
          $bg: (
            width: 410px,
          ),
          $md: (
            width: 100%,
          ),
          $sm: (
            width: 100%,
            padding: 30px 20px,
          ),
        )
      );
      .title-tag {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: bottom;
        justify-content: flex-start;

        .h2 {
          background: #ffffff !important;
          overflow: hidden !important;
          z-index: 2 !important;
          padding-bottom: 15px !important;
          line-height: 32px !important;
          font-style: normal !important;
          font-weight: 400 !important;
          @include media(
            (
              $lg: (
                font-size: 36px,
                line-height: 42px,
              ),
              $md: (
                font-size: 28px,
                line-height: 42px,
              ),
              $sm: (
                font-size: 24px,
                line-height: 42px,
              ),
            )
          );
        }
      }
      .form-item-ipt {
        border: none;
        outline: none;
        height: 100%;
        font-size: inherit;
      }
      input::placeholder {
        color: #ccc;
      }
      .colorValue {
        color: #ccc !important;
      }
      .input-error {
        flex-shrink: 0;
        color: getThemeVal(alertColor);
      }
      .form-item {
        padding: 0 10px;
        height: 40px;
        border: 1px solid #eee;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      .arrow-dow {
        height: 20px;
        width: 20px;
        background-position: center;
        background-size: cover;
        background-image: url(https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210611114753218-icon_common_arrows_24_dow_gray@3x.png);
      }
      .form-contact {
        height: 80px;
        display: flex;
        align-items: center;
        cursor: pointer;
      }
      .form-radio-label {
        padding-left: 10px;
      }
      .textSubtitleColor {
        color: getThemeVal(textSubtitleColor);
      }
      .form-btn {
        // @include mainButton(getThemeVal(brandColors));
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 60px;
        border: 0px solid #00b7ef29;
        background-color: #00b7ef29;
        color: #ffffff;
        border-radius: 50px;
        @include media(
          (
            $lg: (
              height: 48px,
              font-size: 18px,
            ),
          )
        );
      }
      .form-btn-background {
        background-color: #00b9ef !important;
      }
    }
  }
  .bosFixed {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 2;
    background-color: rgba(0, 0, 0, 0.4);
  }
}
.dialog-body {
  position: relative;
  .dialog-body-privacy {
    overflow: hidden;
    border-radius: 10px;
    background: #fff;
  }
  .privacy {
    width: 800px;
    padding: 20px;
    max-width: 80vw;
    height: 80vh;
    overflow: hidden;
    iframe {
      border: none;
    }
  }

  .dialog-close {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    position: absolute;
    left: 50%;
    bottom: -50px;
    transform: translateX(-50%);
    z-index: 199;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(24, 26, 36, 1);
    cursor: pointer;
    img {
      display: block;
      width: 100%;
    }
  }
}
#login-scan {
  display: flex;
  justify-content: center;
  height: 316px;
  // align-items: flex-end;
  align-items: center !important;
}
</style>
